export default __webpack_public_path__ + "static/media/Pricing.9a28bf18.png";